<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
          ref="previewEl"
          :src="userData.avatar"
          size="90px"
          rounded
        />
      </template>
      <h4 class="mb-1">
        {{ userData.titleName }} {{ userData.firstName }} {{ userData.lastName }}
      </h4>
      <div class="d-flex flex-wrap">
        <b-button
          variant="primary"
          @click="$refs.refInputEl.click()"
        >
          <input
            ref="refInputEl"
            type="file"
            class="d-none"
            @input="inputImageRenderer"
          >
          <span class="d-none d-sm-inline">Update</span>
          <feather-icon
            icon="EditIcon"
            class="d-inline d-sm-none"
          />
        </b-button>
        <b-button
          variant="outline-secondary"
          class="ml-1"
        >
          <span class="d-none d-sm-inline">Remove</span>
          <feather-icon
            icon="TrashIcon"
            class="d-inline d-sm-none"
          />
        </b-button>
      </div>
    </b-media>

    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon
        icon="UserIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        Personal Information
      </h4>
    </div>

    <!-- User Info: Input Fields -->
    <b-form class="mt-1">
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="ID Card Number"
            label-for="idCardNumber"
          >
            <b-form-input
              id="idCardNumber"
              v-model="userData.idCardNumber"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Employee Name"
            label-for="employeeId"
          >
            <b-form-input
              id="employeeId"
              v-model="userData.employeeId"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Password"
            label-for="password"
          >
            <b-input-group
              class="input-group-merge"
            >
              <b-form-input
                id="password"
                v-model="userData.password"
                class="form-control-merge"
                :type="passwordFieldType"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Tittle Name"
            label-for="titleName"
          >
            <!-- <b-form-input
              id="titleName"
              v-model="userData.titleName"
            /> -->
            <v-select
              v-model="userData.titleName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="titleOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="First Name"
            label-for="firstName"
          >
            <b-form-input
              id="firstName"
              v-model="userData.firstName"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Last Name"
            label-for="lastName"
          >
            <b-form-input
              id="lastName"
              v-model="userData.lastName"
            />
          </b-form-group>
        </b-col>

        <!-- <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Gender"
            label-for="gender"
          >
            <b-form-radio-group
              id="gender"
              v-model="userData.gender"
              :options="genderOptions"
            />
          </b-form-group>
        </b-col> -->

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Gender"
            label-for="gender"
          >
            <v-select
              v-model="userData.gender"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="genderOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Nickname"
            label-for="nickname"
          >
            <b-form-input
              id="nickname"
              v-model="userData.nickname"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Birth Date"
            label-for="birthDate"
          >
            <b-form-datepicker
              id="birthDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="en"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Permission Group"
            label-for="permissionGroup"
          >
            <v-select
              v-model="userData.permissionGroup"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="permissionGroupOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Status"
            label-for="status"
          >
            <v-select
              v-model="userData.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <b-button
      variant="primary"
      class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Save Changes
    </b-button>
    <b-button
      variant="outline-secondary"
      type="reset"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset
    </b-button>
  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BForm, BTable,
  BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormDatepicker, BFormRadioGroup,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import useUsersList from '../users-list/useUsersList'

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    BFormDatepicker,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormRadioGroup,
    vSelect,
  },
  mixins: [togglePasswordVisibility],
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList()

    const titleOptions = [
      { label: 'Mr.', value: 'Mr.' },
      { label: 'Mrs.', value: 'Mrs.' },
      { label: 'Ms.', value: 'Ms.' },
    ]

    const genderOptions = [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ]

    const permissionGroupOptions = [
      { label: 'Director', value: 'director' },
      { label: 'Finance', value: 'finance' },
      { label: 'Manager', value: 'manager' },
      { label: 'Marketing', value: 'marketing' },
      { label: 'Sales', value: 'sales' },
    ]

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      props.userData.avatar = base64
    })

    return {
      resolveUserRoleVariant,
      avatarText,
      titleOptions,
      genderOptions,
      permissionGroupOptions,
      statusOptions,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
